import { render, staticRenderFns } from "./ExpandUsers.vue?vue&type=template&id=7fa4e84b&scoped=true&"
import script from "./ExpandUsers.vue?vue&type=script&lang=js&"
export * from "./ExpandUsers.vue?vue&type=script&lang=js&"
import style0 from "./ExpandUsers.vue?vue&type=style&index=0&id=7fa4e84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4e84b",
  null
  
)

component.options.__file = "ExpandUsers.vue"
export default component.exports